import React, { Component } from 'react'
import { connect as connectRedux } from 'react-redux'
import { compose } from 'recompose'
import { bindActionCreators } from 'redux'
import { Map, List } from 'immutable'
import _pick from 'lodash/pick'
// import _get from 'lodash/get'
import _debounce from 'lodash/debounce'
import { Container, Grid, Typography, MenuItem } from '@mui/material'
import Loader from 'gui/components/common/Loader'
import MuiForm from 'gui/components/common/MuiForm'
import MuiButton from 'gui/components/common/MuiButton'
import MuiTextFieldWrapper from 'gui/components/common/MuiTextField'
import MuiSelectWrapper from 'gui/components/common/MuiSelect'
import Pagination from 'gui/components/pagination'
import { createLocationHref } from 'services/location'
import {
  getCSParams as getCSParamsAction,
  createCSParam as createCSParamAction,
  removeCSParam as removeCSParamAction,
  updateCSParam as updateCSParamAction,
  clearError as clearCSParamAction,
  processReindex as processReindexAction,
} from 'services/content-search/redux/actions'
import connectHistory from 'gui/components/router/connect'
import './index.scss'

function createEmpty () {
  return Map({
    contentType: 'any',
    searchColumn: '',
    referenceRecord: null,
    weight: 1,
    metaphone: false,
    id: null,
  })
}

function renderLoader () {
  return (
    <div className="loader-container">
      <Loader />
      <div className="loader__update-mask" />
    </div>
  )
}

const contentTypes = List(['any', 'video', 'series', 'people'])
const searchColumns = List([
  '',
  'title',
  'shortDescription',
  'description',
  'instructor',
  'cast',
  'createdAt',
  'updatedAt',
  'searchKeywords',
  'searchTitle',
])
const referenceTypes = List([
  '',
  'all',
  'series',
  'category',
  'centers',
  'genres',
  'author',
  'yoga-style',
  'yoga-teacher',
  'yoga-focus',
  'fitness-instructor',
  'fitness-style',
  'interview-host',
  'interview-guest',
])

const makeSelection = (ct, i) => (
  <MenuItem key={`ct-${i}`} value={ct}>
    {ct}
  </MenuItem>
)

class CSParamsDataTable extends Component {
  constructor (props) {
    super(props)
    const { location } = props
    const query = location.getIn(['data', 'query']) || new Map()
    this.state = {
      editableEntity: null,
      filterContentType: query.get('contentType') || '',
      filterSearchColumn: query.get('searchColumn') || '',
    }
  }

  componentDidMount () {
    this.setFilterOptionValueDebounced = _debounce(this.setFilterOptionValue, 700)
  }

  componentDidUpdate (prevProps) {
    const { props } = this
    const { clearError, csParams, location } = props
    const error = csParams.get('error')

    if (error) {
      alert(error)
      clearError()
    }

    // Sync local filter state if location/query changes (e.g. navigation)
    if (location !== prevProps.location) {
      const query = location.getIn(['data', 'query']) || new Map()
      this.setState({
        filterContentType: query.get('contentType') || '',
        filterSearchColumn: query.get('searchColumn') || '',
      })
    }
  }

  /**
   * Handle an onchange event from pagination
   */
  onChangePage = (page) => {
    const { csParams, location, storeKey } = this.props
    const offset = csParams.getIn([storeKey, 'limit']) * (page - 1)
    global.location.href = createLocationHref(location.setIn(['data', 'query', 'offset'], offset))
  }

  renderCSParamRow = ({ csParam }) => {
    const csParamContentType = csParam.get('contentType')
    const csParamSearchColumn = csParam.get('searchColumn')
    const csParamReferenceRecord = csParam.get('referenceRecord')
    const csParamWeight = csParam.get('weight')
    const csParamMetaphoneFlag = csParam.get('metaphone')
    const csParamId = csParam.get('id', null)
    const csParamKey = csParamId ? `csParam-row${csParamId}` : ''
    return (
      <div className="csParams-table__list" key={csParamKey}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <a href="#" onClick={this.editCSParam(csParam)}>
              {csParamContentType}
            </a>
          </Grid>
          <Grid item xs={3}>
            <a href="#" onClick={this.editCSParam(csParam)}>
              {csParamReferenceRecord}
            </a>
          </Grid>
          <Grid item xs={2}>
            <a href="#" onClick={this.editCSParam(csParam)}>
              {csParamSearchColumn}
            </a>
          </Grid>
          <Grid item xs={2}>
            <a href="#" onClick={this.editCSParam(csParam)}>
              {csParamWeight}
            </a>
          </Grid>
          <Grid item xs={2}>
            <a href="#" onClick={this.editCSParam(csParam)}>
              {csParamMetaphoneFlag ? 'true' : 'false'}
            </a>
          </Grid>
        </Grid>
      </div>
    )
  }

  onEditChange = (e, field) => {
    e.preventDefault()
    const { state } = this
    let { editableEntity } = state
    let { value } = e.target

    if (field === 'metaphone') {
      // Convert string to boolean for metaphone field
      value = value === 'true'
    }

    editableEntity = editableEntity.set(field, value)
    this.setState({
      formIsDirty: true,
      editableEntity,
    })
  }

  setFilterOptionValue = ({ value, filter }) => {
    const { history, location } = this.props
    let href
    const newLocation = location.setIn(['data', 'query', 'offset'], 0)
    if (value === '') {
      href = createLocationHref(newLocation.deleteIn(['data', 'query', filter]))
    } else {
      href = createLocationHref(newLocation.setIn(['data', 'query', filter], value))
    }
    history.replace(href)
  }

  /**
   * Handle a change event for the filter options
   */
  onChangeFilterOption = (e, filter) => {
    const { value } = e.target
    // Update local state immediately
    if (filter === 'contentType') {
      this.setState({ filterContentType: value })
    } else if (filter === 'searchColumn') {
      this.setState({ filterSearchColumn: value })
    }
    // Debounce the Redux/URL update
    this.setFilterOptionValueDebounced({ value, filter })
  }

  renderList = () => {
    const { props, onChangePage } = this
    const { storeKey, csParams } = props
    const offset = csParams.getIn([storeKey, 'offset'])
    const limit = csParams.getIn([storeKey, 'limit'])
    const data = csParams.getIn([storeKey, 'data'], List())
    // const rowStyle = { backgroundColor: '#c8e6c9', border: '3px solid black' };
    return (
      <div>
        <div className="csParams-table">
          <Container maxWidth={false}>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                Content Type:
              </Grid>
              <Grid item xs={3}>
                Reference Type:
              </Grid>
              <Grid item xs={2}>
                Search Column:
              </Grid>
              <Grid item xs={2}>
                Weight:
              </Grid>
              <Grid item xs={2}>
                Metaphone?
              </Grid>
            </Grid>
            {data.map((csParam, i) => this.renderCSParamRow({ csParam, i }))}
          </Container>
        </div>
        <Pagination
          onChangePage={onChangePage}
          page={offset / limit + 1}
          itemsPerPage={csParams.getIn([storeKey, 'limit'])}
          totalItemCount={csParams.getIn([storeKey, 'total'])}
        />
      </div>
    )
  }

  renderBody = () => {
    const { props } = this
    const { storeKey, csParams } = props
    const processing = csParams.getIn([storeKey, 'processing'])
    const data = csParams.getIn([storeKey, 'data'], List())

    if (data.size === 0) {
      return <div>Sorry no csParams were found.</div>
    }
    if (processing) {
      return renderLoader()
    }
    return this.renderList()
  }

  render () {
    const { onChangeFilterOption } = this
    const { filterContentType, filterSearchColumn } = this.state
    return (
      <Container
        className="csParams-list-data-table csParams-list-data-table--list"
        maxWidth={false}
      >
        <MuiForm className="csParams-filters">
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={3} md={2}>
              <h3 className="csParams-filters__title">Filter Parameters:</h3>
            </Grid>
            <Grid item xs={12} sm={4} md={3} style={{ marginTop: '20px' }}>
              <MuiTextFieldWrapper
                className="csParams-filters__input"
                label="Content Type"
                type="text"
                value={filterContentType}
                onChange={(e) => onChangeFilterOption(e, 'contentType')}
                fullWidth
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3} style={{ marginTop: '20px' }}>
              <MuiTextFieldWrapper
                className="csParams-filters__input"
                label="Search Column"
                type="text"
                value={filterSearchColumn}
                onChange={(e) => onChangeFilterOption(e, 'searchColumn')}
                fullWidth
                variant="outlined"
              />
            </Grid>
          </Grid>
        </MuiForm>
        <div className="csParam__controls">
          <MuiButton className="csParam__add" onClick={this.editCSParam(null)}>
            Add New Search Parameter
          </MuiButton>
          <MuiButton className="csParam__index" onClick={this.forceReindex(null)}>
            Force reindex of search table
          </MuiButton>
        </div>
        {this.renderBody()}
        {this.renderEditView()}
      </Container>
    )
  }

  /**
   * Handle a request for table reindex
   */
  forceReindex () {
    return () => {
      const { processReindex, storeKey } = this.props
      processReindex({ storeKey })
    }
  }

  //* ****************************EDIT CS Param*********************************
  editCSParam (csParam) {
    return () => {
      const n = csParam === null ? createEmpty() : csParam
      if (n) {
        this.setState(() => ({
          editableEntity: n,
          formIsDirty: false,
        }))
      }
    }
  }

  cancelCSParamOnClick = (e) => {
    e.preventDefault()
    this.setState(() => ({
      editableEntity: null,
    }))
  }

  saveCSParamOnClick = (e) => {
    e.preventDefault()

    const { state, props } = this
    const { createCSParam, updateCSParam, storeKey } = props
    const { editableEntity, formIsDirty } = state
    // console.log(`Saving csParam, dirty=${formIsDirty}, entity=${JSON.stringify(editableEntity)}`)
    if (formIsDirty) {
      // if something has changed, otherwise ignore
      // validate no spaces in source field
      const source = editableEntity.get('contentType')
      if (source.indexOf(' ') !== -1) {
        alert('Content Type field must not contain any spaces!\nPlease fix...')
        return
      }
      const csParam = editableEntity.get('searchColumn')
      if (csParam.indexOf(' ') !== -1) {
        alert('Search Column field must not contain any spaces!\nPlease fix...')
        return
      }

      // validate weight field
      const weight = editableEntity.get('weight')
      if (weight === '' || weight === null || weight === undefined) {
        alert('Weight field is required and must be between 1-15!')
        return
      }
      const weightNum = parseInt(weight, 10)
      if (Number.isNaN(weightNum) || weightNum < 1 || weightNum > 15) {
        alert('Weight field must be a number between 1-15!')
        return
      }

      // now good to save it off
      const id = editableEntity.get('id')
      if (id > 0) {
        updateCSParam({ storeKey, data: editableEntity })
      } else {
        createCSParam({ storeKey, data: editableEntity })
      }
    }
    this.setState(() => ({
      editableEntity: null,
      formIsDirty: false,
    }))
  }

  removeCSParamOnClick = (e) => {
    e.preventDefault()
    const { state, props } = this
    const { removeCSParam, storeKey } = props
    const { editableEntity } = state
    const id = editableEntity.get('id')
    // console.log(props)
    if (id) {
      removeCSParam({ storeKey, id })
    }

    this.setState(() => ({
      editableEntity: null,
    }))
  }

  renderEditView () {
    const { state, onEditChange } = this
    const { editableEntity } = state

    if (editableEntity) {
      const editContentType = editableEntity.get('contentType')
      const editSearchColumn = editableEntity.get('searchColumn')
      const editReferenceRecord = editableEntity.get('referenceRecord')
      const editWeight = editableEntity.get('weight')
      const editMetaphone = editableEntity.get('metaphone')
      const editId = editableEntity.get('id', null)
      const createdAt = new Date(editableEntity.get('createdAt', Date.now()))
      const editCreatedAt = createdAt.toString()
      const updatedAt = new Date(editableEntity.get('updatedAt', Date.now()))
      const editUpdatedAt = updatedAt.toString()
      return (
        <div className="csParams-editable">
          <div className="csParams-editable__body">
            <MuiForm className="csParams-editable__form">
              <Typography variant="h4" component="h1" gutterBottom>
                Edit CSParam
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={2}>
                  <MuiSelectWrapper
                    label="Content Type"
                    name="contentType"
                    value={editContentType || ''}
                    onChange={(e) => onEditChange(e, 'contentType')}
                    required={true}
                  >
                    {contentTypes.map(makeSelection)}
                  </MuiSelectWrapper>
                </Grid>
                <Grid item xs={3}>
                  <MuiSelectWrapper
                    label="Search Column"
                    name="searchColumn"
                    required={true}
                    value={editSearchColumn || ''}
                    onChange={(e) => onEditChange(e, 'searchColumn')}
                  >
                    {searchColumns.map(makeSelection)}
                  </MuiSelectWrapper>
                </Grid>
                <Grid item xs={3}>
                  <MuiSelectWrapper
                    label="Reference Type (if needed)"
                    name="referenceRecord"
                    required={true}
                    value={editReferenceRecord || ''}
                    onChange={(e) => onEditChange(e, 'referenceRecord')}
                  >
                    {referenceTypes.map(makeSelection)}
                  </MuiSelectWrapper>
                </Grid>
                <Grid item xs={2}>
                  <MuiTextFieldWrapper
                    label="Weight"
                    type="text"
                    value={editWeight || ''}
                    onChange={(e) => onEditChange(e, 'weight')}
                    data-property="weight"
                  />
                </Grid>
                <Grid item xs={2}>
                  <MuiSelectWrapper
                    label="Metaphone?"
                    name="metaphone"
                    value={editMetaphone ? 'true' : 'false'}
                    onChange={(e) => onEditChange(e, 'metaphone')}
                    required={true}
                  >
                    <MenuItem value="true">true</MenuItem>
                    <MenuItem value="false">false</MenuItem>
                  </MuiSelectWrapper>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={5}>
                  <MuiTextFieldWrapper
                    label="Created at"
                    type="text"
                    disabled={true}
                    value={editCreatedAt}
                  />
                </Grid>
                <Grid item xs={5}>
                  <MuiTextFieldWrapper
                    label="Updated at"
                    type="text"
                    disabled={true}
                    value={editUpdatedAt}
                  />
                </Grid>
              </Grid>
              <div className="mui--pull-right">
                <MuiButton onClick={this.cancelCSParamOnClick}>Cancel</MuiButton>
                {editId ? <MuiButton onClick={this.removeCSParamOnClick}>Remove</MuiButton> : null}
                <MuiButton onClick={this.saveCSParamOnClick}>Save</MuiButton>
              </div>
            </MuiForm>
          </div>
        </div>
      )
    }
    return null
  }
}

export default compose(
  connectRedux(
    (state) => _pick(state, ['csParams', 'location']),
    (dispatch) =>
      bindActionCreators(
        {
          getCSParams: getCSParamsAction,
          removeCSParam: removeCSParamAction,
          createCSParam: createCSParamAction,
          updateCSParam: updateCSParamAction,
          processReindex: processReindexAction,
          clearError: clearCSParamAction,
        },
        dispatch,
      ),
  ),
  connectHistory(),
)(CSParamsDataTable)
